const initGlobalHealthLink = () => {
  const links = document.querySelectorAll(".js-global-health-link");

  let queryString = window.location.search;

  setInterval(() => {
    if (queryString !== window.location.search) {
      queryString = window.location.search;
    }
  }, 500);

  links.forEach((link) => {
    const linkhref = link.href;
    link.href = `${linkhref}${queryString}`;
  });
};

export default initGlobalHealthLink;
